
const QueryRoot = {
  "name": "QueryRoot",
  "kind": "OBJECT",
  "fieldBaseTypes": {
    "app": "App",
    "appByHandle": "App",
    "appByKey": "App",
    "appDiscountType": "AppDiscountType",
    "appDiscountTypes": "AppDiscountType",
    "appInstallation": "AppInstallation",
    "appInstallations": "AppInstallationConnection",
    "automaticDiscount": "DiscountAutomatic",
    "automaticDiscountNode": "DiscountAutomaticNode",
    "automaticDiscountNodes": "DiscountAutomaticNodeConnection",
    "automaticDiscountSavedSearches": "SavedSearchConnection",
    "automaticDiscounts": "DiscountAutomaticConnection",
    "availableCarrierServices": "DeliveryCarrierServiceAndLocations",
    "availableLocales": "Locale",
    "carrierService": "DeliveryCarrierService",
    "channel": "Channel",
    "channels": "ChannelConnection",
    "checkoutProfile": "CheckoutProfile",
    "checkoutProfiles": "CheckoutProfileConnection",
    "codeDiscountNode": "DiscountCodeNode",
    "codeDiscountNodeByCode": "DiscountCodeNode",
    "codeDiscountNodes": "DiscountCodeNodeConnection",
    "codeDiscountSavedSearches": "SavedSearchConnection",
    "collection": "Collection",
    "collectionByHandle": "Collection",
    "collectionRulesConditions": "CollectionRuleConditions",
    "collectionSavedSearches": "SavedSearchConnection",
    "collections": "CollectionConnection",
    "companies": "CompanyConnection",
    "company": "Company",
    "companyContact": "CompanyContact",
    "companyContactRole": "CompanyContactRole",
    "companyCount": "Int",
    "companyLocation": "CompanyLocation",
    "companyLocations": "CompanyLocationConnection",
    "currentAppInstallation": "AppInstallation",
    "currentBulkOperation": "BulkOperation",
    "customer": "Customer",
    "customerPaymentMethod": "CustomerPaymentMethod",
    "customerSegmentMembers": "CustomerSegmentMemberConnection",
    "customerSegmentMembership": "SegmentMembershipResponse",
    "customers": "CustomerConnection",
    "deletionEvents": "DeletionEventConnection",
    "deliveryProfile": "DeliveryProfile",
    "deliveryProfiles": "DeliveryProfileConnection",
    "deliverySettings": "DeliverySetting",
    "discountCodeCount": "Int",
    "discountNode": "DiscountNode",
    "discountNodes": "DiscountNodeConnection",
    "discountRedeemCodeBulkCreation": "DiscountRedeemCodeBulkCreation",
    "discountRedeemCodeSavedSearches": "SavedSearchConnection",
    "dispute": "ShopifyPaymentsDispute",
    "disputeEvidence": "ShopifyPaymentsDisputeEvidence",
    "domain": "Domain",
    "draftOrder": "DraftOrder",
    "draftOrderSavedSearches": "SavedSearchConnection",
    "draftOrderTag": "DraftOrderTag",
    "draftOrders": "DraftOrderConnection",
    "fileSavedSearches": "SavedSearchConnection",
    "files": "FileConnection",
    "fulfillment": "Fulfillment",
    "fulfillmentOrder": "FulfillmentOrder",
    "fulfillmentService": "FulfillmentService",
    "giftCard": "GiftCard",
    "giftCards": "GiftCardConnection",
    "giftCardsCount": "UnsignedInt64",
    "inventoryItem": "InventoryItem",
    "inventoryItems": "InventoryItemConnection",
    "inventoryLevel": "InventoryLevel",
    "job": "Job",
    "location": "Location",
    "locations": "LocationConnection",
    "locationsAvailableForDeliveryProfiles": "Location",
    "locationsAvailableForDeliveryProfilesConnection": "LocationConnection",
    "manualHoldsFulfillmentOrders": "FulfillmentOrderConnection",
    "market": "Market",
    "marketByGeography": "Market",
    "marketLocalizableResource": "MarketLocalizableResource",
    "marketLocalizableResources": "MarketLocalizableResourceConnection",
    "marketLocalizableResourcesByIds": "MarketLocalizableResourceConnection",
    "marketingActivities": "MarketingActivityConnection",
    "marketingActivity": "MarketingActivity",
    "marketingEvent": "MarketingEvent",
    "marketingEvents": "MarketingEventConnection",
    "markets": "MarketConnection",
    "metafield": "Metafield",
    "metafieldDefinition": "MetafieldDefinition",
    "metafieldDefinitionTypes": "MetafieldDefinitionType",
    "metafieldDefinitions": "MetafieldDefinitionConnection",
    "metafieldStorefrontVisibilities": "MetafieldStorefrontVisibilityConnection",
    "metafieldStorefrontVisibility": "MetafieldStorefrontVisibility",
    "node": "Node",
    "nodes": "Node",
    "order": "Order",
    "orderPaymentStatus": "OrderPaymentStatus",
    "orderSavedSearches": "SavedSearchConnection",
    "orders": "OrderConnection",
    "paymentTermsTemplates": "PaymentTermsTemplate",
    "priceList": "PriceList",
    "priceLists": "PriceListConnection",
    "priceRule": "PriceRule",
    "priceRuleSavedSearches": "SavedSearchConnection",
    "priceRules": "PriceRuleConnection",
    "primaryMarket": "Market",
    "privateMetafield": "PrivateMetafield",
    "privateMetafields": "PrivateMetafieldConnection",
    "product": "Product",
    "productByHandle": "Product",
    "productResourceFeedback": "ProductResourceFeedback",
    "productSavedSearches": "SavedSearchConnection",
    "productVariant": "ProductVariant",
    "productVariants": "ProductVariantConnection",
    "products": "ProductConnection",
    "publicApiVersions": "ApiVersion",
    "publication": "Publication",
    "publications": "PublicationConnection",
    "refund": "Refund",
    "scriptTag": "ScriptTag",
    "scriptTags": "ScriptTagConnection",
    "segment": "Segment",
    "segmentCount": "Int",
    "segmentFilterSuggestions": "SegmentFilterConnection",
    "segmentFilters": "SegmentFilterConnection",
    "segmentMigrations": "SegmentMigrationConnection",
    "segmentValueSuggestions": "SegmentValueConnection",
    "segments": "SegmentConnection",
    "sellingPlanGroup": "SellingPlanGroup",
    "sellingPlanGroups": "SellingPlanGroupConnection",
    "shop": "Shop",
    "shopLocales": "ShopLocale",
    "shopifyPaymentsAccount": "ShopifyPaymentsAccount",
    "staffMember": "StaffMember",
    "standardMetafieldDefinitionTemplates": "StandardMetafieldDefinitionTemplateConnection",
    "subscriptionBillingAttempt": "SubscriptionBillingAttempt",
    "subscriptionBillingCycle": "SubscriptionBillingCycle",
    "subscriptionBillingCycles": "SubscriptionBillingCycleConnection",
    "subscriptionContract": "SubscriptionContract",
    "subscriptionContracts": "SubscriptionContractConnection",
    "subscriptionDraft": "SubscriptionDraft",
    "tenderTransactions": "TenderTransactionConnection",
    "translatableResource": "TranslatableResource",
    "translatableResources": "TranslatableResourceConnection",
    "translatableResourcesByIds": "TranslatableResourceConnection",
    "urlRedirect": "UrlRedirect",
    "urlRedirectImport": "UrlRedirectImport",
    "urlRedirectSavedSearches": "SavedSearchConnection",
    "urlRedirects": "UrlRedirectConnection",
    "webPixel": "WebPixel",
    "webhookSubscription": "WebhookSubscription",
    "webhookSubscriptions": "WebhookSubscriptionConnection"
  },
  "implementsNode": false
};
export default QueryRoot;